import React from "react";
import { useTranslation } from "react-i18next";

import {
  sponsoredByLogoLine1,
  sponsoredByLogoLine2,
  sponsoredByLogoLine3,
  supportedByLogo,
  ticketingByLogo,
  djPerformByLogo,
  presentedByLogo,
  communityPartnerLogo,
  mediaByLogo,
  venueByLogo,
} from "utils/constants/data";

function OurSponsors({ landingPage }) {
  const { t } = useTranslation();

  const sponsors = {
    sponsoredBy: (
      <div className="space-y-6">
        <div className="grid grid-cols-2 gap-4 items-center place-items-center app-animation-translate-start">
          {sponsoredByLogoLine1 &&
            sponsoredByLogoLine1.map((logo) => {
              return (
                <img
                  src={logo && logo.image_url}
                  className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain"
                  alt="client-logo"
                />
              );
            })}
          {/* <p><b>{t('manyMore')}</b></p> */}
        </div>
        <div className="grid grid-cols-5 2xl:grid-cols-5 gap-4 items-center place-items-center app-animation-translate-start">
          {sponsoredByLogoLine2 &&
            sponsoredByLogoLine2.map((logo) => {
              return (
                <img
                  src={logo && logo.image_url}
                  className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain"
                  alt="client-logo"
                />
              );
            })}
          {/* <p><b>{t('manyMore')}</b></p> */}
        </div>
        <div className="grid grid-cols-5 2xl:grid-cols-5 gap-4 items-center place-items-center app-animation-translate-start">
          {sponsoredByLogoLine3 &&
            sponsoredByLogoLine3.map((logo) => {
              return (
                <img
                  src={logo && logo.image_url}
                  className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain"
                  alt="client-logo"
                />
              );
            })}
          {/* <p><b>{t('manyMore')}</b></p> */}
        </div>
      </div>
    ),
    ticketingSytem: (
      <div className="grid grid-cols-1 gap-4 items-center place-items-center app-animation-translate-start">
        {ticketingByLogo &&
          ticketingByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain"
                alt="client-logo"
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    djPerformance: (
      <div className="grid grid-cols-1 gap-4 items-center place-items-center app-animation-translate-start">
        {djPerformByLogo &&
          djPerformByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain"
                alt="client-logo"
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    venuePartner: (
      <div className="grid grid-cols-2 gap-4 items-center place-items-center app-animation-translate-start">
        {venueByLogo &&
          venueByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[250px] object-contain"
                alt="client-logo"
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    mediaPartner: (
      <div className="grid grid-cols-2 gap-4 items-center place-items-center app-animation-translate-start">
        {mediaByLogo &&
          mediaByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[250px] object-contain"
                alt="client-logo"
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    supportedBy: (
      <div className="grid grid-cols-4 gap-4 items-center place-items-center app-animation-translate-start">
        {supportedByLogo &&
          supportedByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain"
                alt="client-logo"
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    presentedBy: (
      <div className="grid grid-cols-3 gap-8 items-center place-items-center app-animation-translate-start">
        {presentedByLogo &&
          presentedByLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain"
                alt="client-logo"
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    communityPartner: (
      <div className="grid grid-cols-4 gap-4 items-center place-items-center app-animation-translate-start">
        {communityPartnerLogo &&
          communityPartnerLogo.map((logo) => {
            return (
              <img
                src={logo && logo.image_url}
                className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain"
                alt="client-logo"
              />
            );
          })}
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
  };

  return (
    <div>
      {!landingPage && (
        <section>
          <div className="relative">
            <img
              src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/5d6260b8cfe0d87c4a84f3a5be2650499d800596cfce422c1df4d6ad7ef66ac73e72223a02bc359af82907bc4962a5bde782b98cf6f04acd5b072181c840dee2e83264308a41794bba2f65554c8c1370a8beb05e7e4ade2120a9cbc270fb612404aad78654ef72d443bbe9abdcef9080e234b5b041345fd706c0/file-1751858972759.JPG"
              alt="main"
              className="w-full max-h-40 sm:max-h-60 object-cover object-center"
            />
            <div className="absolute top-0 bottom-0 left-0 right-0 bg-black/60 text-white">
              <div className="app-main-container flex flex-col justify-center items-center h-full gap-4 sm:gap-8">
                <p className="text-2xl md:text-3xl/[3rem] lg:text-4xl/[3rem] max-w-md lg:max-w-xl px-8 font-bold text-center app-animation-translate-start">
                  {t("ourSponsorsBanner")}
                </p>
              </div>
            </div>
          </div>
        </section>
      )}
      <section>
        <div className="app-main-container space-y-8">
          <p className="text-xl sm:text-2xl font-bold text-black text-center app-animation-translate-start">
            {t("presentedBy")}
          </p>
          <div className="text-black text-sm sm:text-base max-w-2xl mx-auto">
            {sponsors.presentedBy}
          </div>
        </div>
      </section>
      {/* <section>
        <div className="app-main-container space-y-8">
          <p className="text-xl sm:text-2xl font-bold text-black text-center app-animation-translate-start">
            {t("mainSponsor")}
          </p>
          <div className="text-black text-sm sm:text-base max-w-2xl mx-auto">
            {sponsors.mainSponsor}
          </div>
        </div>
      </section> */}
      <section>
        <div className="app-main-container space-y-8">
          <p className="text-xl sm:text-2xl font-bold text-black text-center app-animation-translate-start">
            {t("sponsoredBy")}
          </p>
          <div className="text-black text-sm sm:text-base max-w-2xl mx-auto">
            {sponsors.sponsoredBy}
          </div>
        </div>
      </section>
      {/* <section>
        <div className="app-main-container space-y-8">
          <p className="text-xl sm:text-2xl font-bold text-black text-center app-animation-translate-start">
            {t("supportedBy")}
          </p>
          <div className="text-black text-sm sm:text-base max-w-2xl mx-auto">
            {sponsors.supportedBy}
          </div>
        </div>
      </section> */}
      <section>
        <div className="app-main-container space-y-8">
          <p className="text-xl sm:text-2xl font-bold text-black text-center app-animation-translate-start">
            {t("mediaPartner")}
          </p>
          <div className="text-black text-sm sm:text-base max-w-2xl mx-auto">
            {sponsors.mediaPartner}
          </div>
        </div>
      </section>
      <section>
        <div className="app-main-container space-y-8">
          <p className="text-xl sm:text-2xl font-bold text-black text-center app-animation-translate-start">
            {t("eTicketingSystem")}
          </p>
          <div className="text-black text-sm sm:text-base max-w-2xl mx-auto">
            {sponsors.ticketingSytem}
          </div>
        </div>
      </section>
      {/* <section>
        <div className='app-main-container space-y-8'>
          <p className='text-xl sm:text-2xl font-bold text-black text-center app-animation-translate-start'>
            {t('djPerformance')}
          </p>
          <div className='text-black text-sm sm:text-base max-w-2xl mx-auto'>{sponsors.djPerformance}</div>
        </div>
      </section> */}
      <section>
        <div className="app-main-container space-y-8">
          <p className="text-xl sm:text-2xl font-bold text-black text-center app-animation-translate-start">
            {t("venuePartner")}
          </p>
          <div className="text-black text-sm sm:text-base max-w-2xl mx-auto">
            {sponsors.venuePartner}
          </div>
        </div>
      </section>
      {/* <section>
        <div className='app-main-container space-y-8'>
          <p className='text-xl sm:text-2xl font-bold text-black text-center app-animation-translate-start'>
            {t('communityPartner')}
          </p>
          <div className='text-black text-sm sm:text-base max-w-2xl mx-auto'>{sponsors.communityPartner}</div>
        </div>
      </section> */}
    </div>
  );
}

export default OurSponsors;
